import Notification from './Notification';
import React from 'react';

class VersionWarning extends React.Component {

    render() {

        return (
            <div style={{ maxWidth: 800 }}>
                <Notification dataTest="version-warning" text="This resource is a project version and cannot be accessed." />
            </div>
        );
    }
}

export default VersionWarning;